import React, { useState, useEffect } from "react";
import Screen from "../shared/screen";
import { axiosInstance } from "../../config/apiTemplate";
import { DataGridPro, GridToolbarContainer, GridToolbarColumnsButton, GridToolbarFilterButton, GridToolbarDensitySelector, GridOverlay } from "@mui/x-data-grid-pro";
import CircularProgress from "@mui/material/CircularProgress";
import LinearProgress from "@mui/material/LinearProgress";
import DownloadIcon from "@mui/icons-material/Download";
import IconButton from "@mui/material/IconButton";
import "./style.css";

function SavingsReportsPage() {
  const [isLoading, setLoading] = useState(true);
  const [reports, setReports] = useState([]);
  let t_id = localStorage.getItem("t_id");

  useEffect(() => {
    document.title = "ETSW - Savings Reports";
    getReports();
  }, []);

  async function getReports() {
    setLoading(true);
    const url = "client_api/savings/getReports.php";
    let form = new FormData();
    form.append("t_id", t_id);
    form.append("type", 0);
    form.append("productView", "Savings MM");
    try {
      const response = await axiosInstance.post(url, form);
      if (response.data.status === 201) {
        setReports(response.data.reports);
      }
    } catch (e) {
      console.log(e);
    }
    setLoading(false);
  }

  async function downloadReport(filename) {
    setLoading(true);
    let form = new FormData();
    form.append("filename", filename);
    form.append("t_id", t_id);
    form.append("type", 0);
    const url = "client_api/reports/getAuthUrl.php";
    try {
      const response = await axiosInstance.post(url, form);
      if (response.data.status === 201) {
        window.open(response.data.url, "_blank");
      }
      setLoading(false);
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  }

  function prepareTableRows() {
    return reports.map((item, index) => ({ ...item, id: index, no: index + 1 }));
  }

  function loadingOverlay() {
    return (
      <GridOverlay>
        <div style={{ position: "absolute", top: 0, width: "100%" }}>
          <LinearProgress />
        </div>
      </GridOverlay>
    );
  }

  function renderNoRows() {
    return (
      <GridOverlay>
        <div>
          <h6 style={{ fontStyle: "italic" }}>No Reports Available....</h6>
        </div>
      </GridOverlay>
    );
  }

  function renderCustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
      </GridToolbarContainer>
    );
  }

  function renderLoading() {
    return (
      <div className="text-center">
        <CircularProgress />
        <p>Fetching Data...</p>
      </div>
    );
  }

  function renderBody() {
    return (
      <div className="row mt-3">
        <div className="col">
          {isLoading ? renderLoading() : (
            <div style={{ minHeight: "65vh", display: "flex" }}>
              <div style={{ flexGrow: 1, backgroundColor: "white", marginTop: 20 }}>
                <DataGridPro
                  density="compact"
                  loading={isLoading}
                  columns={[
                    { field: "no", headerName: "No.", flex: 1 },
                    { field: "report_name", headerName: "Report Name", minWidth: 150, flex: 2 },
                    {
                      field: "report_url",
                      headerName: "Action",
                      minWidth: 150,
                      flex: 2,
                      renderCell: (params) => (
                        <IconButton color="primary" onClick={() => downloadReport(params.value)}>
                          <DownloadIcon />
                        </IconButton>
                      ),
                    },
                  ]}
                  pagination
                  rows={prepareTableRows()}
                  components={{
                    Toolbar: renderCustomToolbar,
                    LoadingOverlay: loadingOverlay,
                    NoRowsOverlay: renderNoRows,
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  function invokeRefresh() {
    getReports();
  }

  return (
    <div>
      <Screen origin="savings-reports" invokeRefresh={invokeRefresh}>
        <div className="container-fluid">
          {renderBody()}
        </div>
        <br />
      </Screen>
    </div>
  );
}

export default SavingsReportsPage;
